import getGuardian from 'graphql/queries/getGuardian';

export const initializeGuardian = (cache, data) => {
  const queryData = {
    guardian: data,
  };
  cache.writeQuery({ query: getGuardian, data: queryData });
};
